import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Textarea } from "@/components/ui/textarea";

export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel = "Konfirmasi", destructive, onConfirm, note, setNote, noteLabel, testId = "confirm-dialog", loading }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid={testId} className="surface">
      <AlertDialogHeader>
        <AlertDialogTitle className="font-heading">{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      {setNote && (
        <div className="space-y-1.5">
          <label className="eyebrow">{noteLabel || "Catatan"}</label>
          <Textarea data-testid={`${testId}-note`} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Tulis alasan / catatan..." />
        </div>
      )}
      <AlertDialogFooter>
        <AlertDialogCancel data-testid={`${testId}-cancel`}>Batal</AlertDialogCancel>
        <AlertDialogAction data-testid={`${testId}-confirm`} disabled={loading} onClick={onConfirm} className={destructive ? "bg-destructive text-destructive-foreground hover:bg-destructive/90" : ""}>
          {loading ? "Memproses..." : confirmLabel}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
